const CONF_API = {
    ATTENDENCE_BY_EMPLOYEE_ID:"api/attendence/list",
    MARK_ATTENDENCE:"api/attendence/mark",
    EDIT_ATTENDENCE:"api/attendence/edit",
    ALL_ATTENDENCE:"api/attendence",
}


export default CONF_API